import type {
  ModbusActionType,
  ModbusByteOrder,
  ModbusRegisterDto,
  ModbusRegisterType,
  ModbusValueType,
} from "~/types/api";

export const deafaultModbusRegister = {
  modbusMasterId: undefined,
  slave: 1,
  type: 0,
  valueType: 0,
  byteOrder: 1,
  key: "",
  register: 1,
  pollInterval: 600,
} as ModbusRegisterDto;

export const ModbusByteOrderEnum = {
  ABCD: 0 as ModbusByteOrder,
  DCBA: 1 as ModbusByteOrder, //Default
  BADC: 2 as ModbusByteOrder,
  CDAB: 3 as ModbusByteOrder,
};

export const ModbusValueTypeEnum = {
  FLOAT: 0 as ModbusValueType,
  DOUBLE: 1 as ModbusValueType,
  INT16: 2 as ModbusValueType,
  UINT16: 3 as ModbusValueType,
  INT32: 4 as ModbusValueType,
  UINT32: 5 as ModbusValueType,
  BOOL: 6 as ModbusValueType,
};

export const ModbusRegisterTypeEnum = {
  HOLDING_REGISTER: 0 as ModbusRegisterType,
  COIL: 1 as ModbusRegisterType,
  ANALOG_INPUT: 2 as ModbusRegisterType,
  DIGITAL_INPUT: 3 as ModbusRegisterType,
};

export const modbusByteOrders = Object.values(ModbusByteOrderEnum);
export const modbusValueTypes = Object.values(ModbusValueTypeEnum);
export const modbusRegisterAllTypes = Object.values(ModbusRegisterTypeEnum);

export const ModbusRegisterActionEnum = {
  POLL: 1 as ModbusActionType,
  WRITE: 2 as ModbusActionType,
};

export const modbusRegisterWriteTypes = [
  ModbusRegisterTypeEnum.HOLDING_REGISTER,
  ModbusRegisterTypeEnum.COIL,
];

export function registerCountByValueType(
  valueType: ModbusValueType | undefined,
) {
  switch (valueType) {
    case ModbusValueTypeEnum.INT16:
    case ModbusValueTypeEnum.UINT16:
    case ModbusValueTypeEnum.BOOL:
      return 1;
    case ModbusValueTypeEnum.INT32:
    case ModbusValueTypeEnum.UINT32:
    case ModbusValueTypeEnum.FLOAT:
      return 2;
    case ModbusValueTypeEnum.DOUBLE:
      return 4;
    default:
      console.error("Error invalid modbus ValueType: ", valueType);
      return 1;
  }
}

export function canUseRegister(
  registers: ModbusRegisterDto[],
  register: ModbusRegisterDto,
) {
  const occupied = compileOccupiedRegisters(registers, register);
  const regCount = registerCountByValueType(register.valueType);
  if (register.register == undefined || occupied.includes(register.register))
    return false;

  if (regCount > 1)
    for (var i = 1; i < regCount; i++)
      if (occupied.includes(register.register + i)) return false;

  return true;
}

function compileOccupiedRegisters(
  registers: ModbusRegisterDto[],
  exclude?: ModbusRegisterDto,
) {
  let regs = [];
  for (var reg of registers) {
    // Ignore the currently editing register
    if (
      reg.register == undefined ||
      (exclude?.modbusRegisterId !== undefined &&
        reg?.modbusRegisterId != undefined &&
        exclude?.modbusRegisterId == reg?.modbusRegisterId)
    )
      continue;

    regs.push(reg.register);
    const regCount = registerCountByValueType(reg.valueType);
    if (regCount > 1)
      for (var i = 1; i < regCount; i++) regs.push(reg.register + i);
  }

  return regs;
}
